<template>
  <button
    type="button"
    v-if="visible"
    @click="tapCouponUse(coupon, selectType)"
    :class="[
      cardType,
      disabled && 'disabled',
      isSelected && 'selected',
      isUsing && 'using',
      inModal && 'in-modal'
    ]"
  >
    <template v-if="isUsing">
      <span class="badge">利用中</span>
      <template v-if="inModal">
        <span class="date">
          <span class="caption">ご利用日時</span>
          <span>{{ formattedLastHistory }}</span>
        </span>
      </template>
      <template v-else>
        <span>{{ usedTypeLabel }}</span>
      </template>
    </template>
    <template v-else-if="isSelected">
      <span class="badge">選択中</span>
      <img v-if="selectedTypeIcon" :src="selectedTypeIcon" alt="" />
      <span class="label">
        {{ selectedTypeString }}選択中<br />
        <span v-if="inModal" class="small-caption">（タップで選択解除）</span>
      </span>
    </template>
    <template v-else>
      <img v-if="selectedTypeIcon" :src="selectedTypeIcon" alt="" />
      <span>{{ selectedTypeString }}使う</span>
    </template>
  </button>
</template>

<script>
import { mapGetters } from 'vuex'
import { COUPON_SELECT_TYPE } from '@/store/couponWithCart'
import moment from 'moment'

export default {
  name: 'CouponWithCartCardButton',
  props: {
    coupon: { type: Object, required: true },
    selectType: { type: Object, required: true },
    visible: { type: Boolean, required: true },
    disabled: { type: Boolean, required: true },
    inModal: { type: Boolean, required: true },
    cardType: { type: String, required: true },
    isSelected: { type: Boolean, required: true },
    isUsing: { type: Boolean, required: true }
  },
  computed: {
    ...mapGetters({
      selectedCoupons: 'CouponWithCart/selectedCoupons'
    }),
    selectedTypeString() {
      let string = ''
      if (
        this.selectType.key === COUPON_SELECT_TYPE.eatIn.key
      ) {
        if (this.coupon.data.weborder_coupon_id === null) {
          string = `店舗で`
        } else {
          string = `${this.selectType.label}で`
        }
      } else if (this.selectType.key === COUPON_SELECT_TYPE.gift.key) {
        string = `${this.selectType.label}を`
      }
      return string
    },
    selectedTypeIcon() {
      let icon = null
      if (this.selectType.key !== COUPON_SELECT_TYPE.notYet && this.inModal) {
        const fileName =
          this.selectType.key === COUPON_SELECT_TYPE.eatIn.key
            ? 'eat-in'
            : this.selectType.key
        if (fileName === 'eat-in') {
          if (this.coupon.data.weborder_coupon_id === null) {
            icon = require(`../../assets/img/coupon-with-cart/card-select-type-eat-in-icon_tenpo.svg`)
          } else {
            icon = require(`../../assets/img/coupon-with-cart/card-select-type-eat-in-icon.svg`)
          }
        } else {
          icon = require(`../../assets/img/coupon-with-cart/card-select-type-${fileName}-icon.svg`)
        }
      }
      return icon
    },
    usedTypeLabel() {
      const suffix = '利用中'
      let prefix = ''
      if (this.coupon.data.last_history) {
        if (this.coupon.data.last_history_channel === '0') {
          if (this.coupon.data.weborder_coupon_id === null) {
            prefix = '店舗'
          } else {
            prefix = COUPON_SELECT_TYPE.eatIn.label
          }
        }
      }
      return prefix ? `${prefix}で${suffix}` : suffix
    },
    formattedLastHistory() {
      return moment(this.coupon.data.last_history).format('YYYY/MM/DD HH:mm')
    }
  },
  methods: {
    tapCouponUse(coupon, selectType) {
      if (this.coupon.data.last_history && this.inModal) {
        return
      }
      if (this.disabled) {
        this.$emit('tap-disabled-coupon-use')
      } else {
        this.$emit('tap-coupon-use', { coupon, selectType })
      }
    }
  }
}
</script>
